export default defineNuxtPlugin((nuxtApp) => {
	function translate(obj) {
		// Перевод текстов с бэка
		var locale = nuxtApp.$i18n.locale.value;
		var result;

		if (obj) {
			if (obj[locale]) {
				result = obj[locale];
			} else {
				result = obj["ru"];
			}
		}

		if (result) {
			result = result.replaceAll("&amp;nbsp;", "&nbsp;");
			result = result.replaceAll("&amp;nbsp", "&nbsp;");
		}

		return result;
	}

	function translate2(ru, en) {
		// Перевод фронтовых текстов
		var locale = nuxtApp.$i18n.locale.value;

		if (locale == "ru") {
			return ru;
		}

		if (locale == "en") {
			return en;
		}
	}

	function translate3(obj) {
		// Перевод атласов
		var locale = nuxtApp.$i18n.locale.value;

		return obj[locale];
	}

	return {
		provide: {
			translate: translate,
			translate2: translate2,
			translate3: translate3
		}
	}
})

// все текста из фронта в перевод
